module.exports = __webpack_public_path__ + "static/pensjonat-jesien-15daab68b87b441a70f18a13bd13498c.jpg";